module.exports = __webpack_public_path__ + "img/zhuhai-e572e9.png";